import { Request } from 'express';

export interface State {
  abbreviation: string,
  name: string
}

export interface Country {
  abbreviation: string,
  name: string,
  states?: {
    [abbreviation: string]: State
  }
}

// Generated from https://docs.recurly.com/docs/countries-provinces-and-states
export const countries: {
  [abbreviation: string]: Country
} = {
  AF: { abbreviation: 'AF', name: 'Afghanistan' },
  AX: { abbreviation: 'AX', name: 'Åland Islands' },
  AL: { abbreviation: 'AL', name: 'Albania' },
  DZ: { abbreviation: 'DZ', name: 'Algeria' },
  AS: { abbreviation: 'AS', name: 'American Samoa' },
  AD: { abbreviation: 'AD', name: 'Andorra' },
  AO: { abbreviation: 'AO', name: 'Angola' },
  AI: { abbreviation: 'AI', name: 'Anguilla' },
  AQ: { abbreviation: 'AQ', name: 'Antarctica' },
  AG: { abbreviation: 'AG', name: 'Antigua and Barbuda' },
  AR: { abbreviation: 'AR', name: 'Argentina' },
  AM: { abbreviation: 'AM', name: 'Armenia' },
  AW: { abbreviation: 'AW', name: 'Aruba' },
  AC: { abbreviation: 'AC', name: 'Ascension Island' },
  AU: { abbreviation: 'AU', name: 'Australia' },
  AT: { abbreviation: 'AT', name: 'Austria' },
  AZ: { abbreviation: 'AZ', name: 'Azerbaijan' },
  BS: { abbreviation: 'BS', name: 'Bahamas' },
  BH: { abbreviation: 'BH', name: 'Bahrain' },
  BD: { abbreviation: 'BD', name: 'Bangladesh' },
  BB: { abbreviation: 'BB', name: 'Barbados' },
  BY: { abbreviation: 'BY', name: 'Belarus' },
  BE: { abbreviation: 'BE', name: 'Belgium' },
  BZ: { abbreviation: 'BZ', name: 'Belize' },
  BJ: { abbreviation: 'BJ', name: 'Benin' },
  BM: { abbreviation: 'BM', name: 'Bermuda' },
  BT: { abbreviation: 'BT', name: 'Bhutan' },
  BO: { abbreviation: 'BO', name: 'Bolivia' },
  BA: { abbreviation: 'BA', name: 'Bosnia and Herzegovina' },
  BW: { abbreviation: 'BW', name: 'Botswana' },
  BV: { abbreviation: 'BV', name: 'Bouvet Island' },
  BR: { abbreviation: 'BR', name: 'Brazil' },
  BQ: { abbreviation: 'BQ', name: 'British Antarctic Territory' },
  IO: { abbreviation: 'IO', name: 'British Indian Ocean Territory' },
  VG: { abbreviation: 'VG', name: 'British Virgin Islands' },
  BN: { abbreviation: 'BN', name: 'Brunei' },
  BG: { abbreviation: 'BG', name: 'Bulgaria' },
  BF: { abbreviation: 'BF', name: 'Burkina Faso' },
  BI: { abbreviation: 'BI', name: 'Burundi' },
  CV: { abbreviation: 'CV', name: 'Cabo Verde' },
  KH: { abbreviation: 'KH', name: 'Cambodia' },
  CM: { abbreviation: 'CM', name: 'Cameroon' },
  CA: {
    abbreviation: 'CA',
    name: 'Canada',
    states: {
      AB: { abbreviation: 'AB', name: 'Alberta' },
      BC: { abbreviation: 'BC', name: 'British Columbia' },
      MB: { abbreviation: 'MB', name: 'Manitoba' },
      NB: { abbreviation: 'NB', name: 'New Brunswick' },
      NL: { abbreviation: 'NL', name: 'Newfoundland' },
      NT: { abbreviation: 'NT', name: 'Northwest Territories' },
      NS: { abbreviation: 'NS', name: 'Nova Scotia' },
      NU: { abbreviation: 'NU', name: 'Nunavut' },
      ON: { abbreviation: 'ON', name: 'Ontario' },
      PE: { abbreviation: 'PE', name: 'Prince Edward Island' },
      QC: { abbreviation: 'QC', name: 'Quebec' },
      SK: { abbreviation: 'SK', name: 'Saskatchewan' },
      YT: { abbreviation: 'YT', name: 'Yukon' }
    }
  },
  KY: { abbreviation: 'KY', name: 'Cayman Islands' },
  CF: { abbreviation: 'CF', name: 'Central African Republic' },
  TD: { abbreviation: 'TD', name: 'Chad' },
  CL: { abbreviation: 'CL', name: 'Chile' },
  CN: { abbreviation: 'CN', name: 'China' },
  CX: { abbreviation: 'CX', name: 'Christmas Island' },
  CC: { abbreviation: 'CC', name: 'Cocos [Keeling] Islands' },
  CO: { abbreviation: 'CO', name: 'Colombia' },
  KM: { abbreviation: 'KM', name: 'Comoros' },
  CD: { abbreviation: 'CD', name: 'Congo [Democratic Republic]' },
  CG: { abbreviation: 'CG', name: 'Congo [Republic]' },
  CK: { abbreviation: 'CK', name: 'Cook Islands' },
  CR: { abbreviation: 'CR', name: 'Costa Rica' },
  CI: { abbreviation: 'CI', name: 'Côte d’Ivoire' },
  HR: { abbreviation: 'HR', name: 'Croatia' },
  CU: { abbreviation: 'CU', name: 'Cuba' },
  CY: { abbreviation: 'CY', name: 'Cyprus' },
  CZ: { abbreviation: 'CZ', name: 'Czech Republic' },
  DK: { abbreviation: 'DK', name: 'Denmark' },
  DG: { abbreviation: 'DG', name: 'Diego Garcia' },
  DJ: { abbreviation: 'DJ', name: 'Djibouti' },
  DM: { abbreviation: 'DM', name: 'Dominica' },
  DO: { abbreviation: 'DO', name: 'Dominican Republic' },
  TL: { abbreviation: 'TL', name: 'East Timor' },
  EC: { abbreviation: 'EC', name: 'Ecuador' },
  EG: { abbreviation: 'EG', name: 'Egypt' },
  SV: { abbreviation: 'SV', name: 'El Salvador' },
  GQ: { abbreviation: 'GQ', name: 'Equatorial Guinea' },
  ER: { abbreviation: 'ER', name: 'Eritrea' },
  EE: { abbreviation: 'EE', name: 'Estonia' },
  ET: { abbreviation: 'ET', name: 'Ethiopia' },
  FK: { abbreviation: 'FK', name: 'Falkland Islands' },
  FO: { abbreviation: 'FO', name: 'Faroe Islands' },
  FJ: { abbreviation: 'FJ', name: 'Fiji' },
  FI: { abbreviation: 'FI', name: 'Finland' },
  FR: { abbreviation: 'FR', name: 'France' },
  GF: { abbreviation: 'GF', name: 'French Guiana' },
  PF: { abbreviation: 'PF', name: 'French Polynesia' },
  TF: { abbreviation: 'TF', name: 'French Southern Territories' },
  GA: { abbreviation: 'GA', name: 'Gabon' },
  GM: { abbreviation: 'GM', name: 'Gambia' },
  GE: { abbreviation: 'GE', name: 'Georgia' },
  DE: { abbreviation: 'DE', name: 'Germany' },
  GH: { abbreviation: 'GH', name: 'Ghana' },
  GI: { abbreviation: 'GI', name: 'Gibraltar' },
  GR: { abbreviation: 'GR', name: 'Greece' },
  GL: { abbreviation: 'GL', name: 'Greenland' },
  GD: { abbreviation: 'GD', name: 'Grenada' },
  GP: { abbreviation: 'GP', name: 'Guadeloupe' },
  GU: { abbreviation: 'GU', name: 'Guam' },
  GT: { abbreviation: 'GT', name: 'Guatemala' },
  GG: { abbreviation: 'GG', name: 'Guernsey' },
  GN: { abbreviation: 'GN', name: 'Guinea' },
  GW: { abbreviation: 'GW', name: 'Guinea-Bissau' },
  GY: { abbreviation: 'GY', name: 'Guyana' },
  HT: { abbreviation: 'HT', name: 'Haiti' },
  HM: { abbreviation: 'HM', name: 'Heard Island and McDonald Islands' },
  HN: { abbreviation: 'HN', name: 'Honduras' },
  HK: { abbreviation: 'HK', name: 'Hong Kong' },
  HU: { abbreviation: 'HU', name: 'Hungary' },
  IS: { abbreviation: 'IS', name: 'Iceland' },
  IN: { abbreviation: 'IN', name: 'India' },
  ID: { abbreviation: 'ID', name: 'Indonesia' },
  IR: { abbreviation: 'IR', name: 'Iran' },
  IQ: { abbreviation: 'IQ', name: 'Iraq' },
  IE: { abbreviation: 'IE', name: 'Ireland' },
  IM: { abbreviation: 'IM', name: 'Isle of Man' },
  IL: { abbreviation: 'IL', name: 'Israel' },
  IT: { abbreviation: 'IT', name: 'Italy' },
  JM: { abbreviation: 'JM', name: 'Jamaica' },
  JP: { abbreviation: 'JP', name: 'Japan' },
  JE: { abbreviation: 'JE', name: 'Jersey' },
  JO: { abbreviation: 'JO', name: 'Jordan' },
  KZ: { abbreviation: 'KZ', name: 'Kazakhstan' },
  KE: { abbreviation: 'KE', name: 'Kenya' },
  KI: { abbreviation: 'KI', name: 'Kiribati' },
  KW: { abbreviation: 'KW', name: 'Kuwait' },
  KG: { abbreviation: 'KG', name: 'Kyrgyzstan' },
  LA: { abbreviation: 'LA', name: 'Laos' },
  LV: { abbreviation: 'LV', name: 'Latvia' },
  LB: { abbreviation: 'LB', name: 'Lebanon' },
  LS: { abbreviation: 'LS', name: 'Lesotho' },
  LR: { abbreviation: 'LR', name: 'Liberia' },
  LY: { abbreviation: 'LY', name: 'Libya' },
  LI: { abbreviation: 'LI', name: 'Liechtenstein' },
  LT: { abbreviation: 'LT', name: 'Lithuania' },
  LU: { abbreviation: 'LU', name: 'Luxembourg' },
  MO: { abbreviation: 'MO', name: 'Macao' },
  MK: { abbreviation: 'MK', name: 'Macedonia' },
  MG: { abbreviation: 'MG', name: 'Madagascar' },
  MW: { abbreviation: 'MW', name: 'Malawi' },
  MY: { abbreviation: 'MY', name: 'Malaysia' },
  MV: { abbreviation: 'MV', name: 'Maldives' },
  ML: { abbreviation: 'ML', name: 'Mali' },
  MT: { abbreviation: 'MT', name: 'Malta' },
  MH: { abbreviation: 'MH', name: 'Marshall Islands' },
  MQ: { abbreviation: 'MQ', name: 'Martinique' },
  MR: { abbreviation: 'MR', name: 'Mauritania' },
  MU: { abbreviation: 'MU', name: 'Mauritius' },
  YT: { abbreviation: 'YT', name: 'Mayotte' },
  MX: { abbreviation: 'MX', name: 'Mexico' },
  FM: { abbreviation: 'FM', name: 'Micronesia' },
  MD: { abbreviation: 'MD', name: 'Moldova' },
  MC: { abbreviation: 'MC', name: 'Monaco' },
  MN: { abbreviation: 'MN', name: 'Mongolia' },
  ME: { abbreviation: 'ME', name: 'Montenegro' },
  MS: { abbreviation: 'MS', name: 'Montserrat' },
  MA: { abbreviation: 'MA', name: 'Morocco' },
  MZ: { abbreviation: 'MZ', name: 'Mozambique' },
  MM: { abbreviation: 'MM', name: 'Myanmar [Burma]' },
  NA: { abbreviation: 'NA', name: 'Namibia' },
  NR: { abbreviation: 'NR', name: 'Nauru' },
  NP: { abbreviation: 'NP', name: 'Nepal' },
  NL: { abbreviation: 'NL', name: 'Netherlands' },
  NC: { abbreviation: 'NC', name: 'New Caledonia' },
  NZ: { abbreviation: 'NZ', name: 'New Zealand' },
  NI: { abbreviation: 'NI', name: 'Nicaragua' },
  NE: { abbreviation: 'NE', name: 'Niger' },
  NG: { abbreviation: 'NG', name: 'Nigeria' },
  NU: { abbreviation: 'NU', name: 'Niue' },
  NF: { abbreviation: 'NF', name: 'Norfolk Island' },
  KP: { abbreviation: 'KP', name: 'North Korea' },
  MP: { abbreviation: 'MP', name: 'Northern Mariana Islands' },
  NO: { abbreviation: 'NO', name: 'Norway' },
  OM: { abbreviation: 'OM', name: 'Oman' },
  PK: { abbreviation: 'PK', name: 'Pakistan' },
  PW: { abbreviation: 'PW', name: 'Palau' },
  PS: { abbreviation: 'PS', name: 'Palestinian Territories' },
  PA: { abbreviation: 'PA', name: 'Panama' },
  PG: { abbreviation: 'PG', name: 'Papua New Guinea' },
  PY: { abbreviation: 'PY', name: 'Paraguay' },
  PE: { abbreviation: 'PE', name: 'Peru' },
  PH: { abbreviation: 'PH', name: 'Philippines' },
  PN: { abbreviation: 'PN', name: 'Pitcairn Islands' },
  PL: { abbreviation: 'PL', name: 'Poland' },
  PT: { abbreviation: 'PT', name: 'Portugal' },
  PR: { abbreviation: 'PR', name: 'Puerto Rico' },
  QA: { abbreviation: 'QA', name: 'Qatar' },
  RE: { abbreviation: 'RE', name: 'Réunion' },
  RO: { abbreviation: 'RO', name: 'Romania' },
  RU: { abbreviation: 'RU', name: 'Russia' },
  RW: { abbreviation: 'RW', name: 'Rwanda' },
  BL: { abbreviation: 'BL', name: 'Saint Barthélemy' },
  SH: { abbreviation: 'SH', name: 'Saint Helena' },
  KN: { abbreviation: 'KN', name: 'Saint Kitts and Nevis' },
  LC: { abbreviation: 'LC', name: 'Saint Lucia' },
  MF: { abbreviation: 'MF', name: 'Saint Martin' },
  PM: { abbreviation: 'PM', name: 'Saint Pierre and Miquelon' },
  VC: { abbreviation: 'VC', name: 'Saint Vincent and the Grenadines' },
  WS: { abbreviation: 'WS', name: 'Samoa' },
  SM: { abbreviation: 'SM', name: 'San Marino' },
  ST: { abbreviation: 'ST', name: 'São Tomé and Príncipe' },
  SA: { abbreviation: 'SA', name: 'Saudi Arabia' },
  SN: { abbreviation: 'SN', name: 'Senegal' },
  RS: { abbreviation: 'RS', name: 'Serbia' },
  SC: { abbreviation: 'SC', name: 'Seychelles' },
  SL: { abbreviation: 'SL', name: 'Sierra Leone' },
  SG: { abbreviation: 'SG', name: 'Singapore' },
  SX: { abbreviation: 'SX', name: 'Sint Maarten [Dutch part]' },
  SK: { abbreviation: 'SK', name: 'Slovakia' },
  SI: { abbreviation: 'SI', name: 'Slovenia' },
  SB: { abbreviation: 'SB', name: 'Solomon Islands' },
  SO: { abbreviation: 'SO', name: 'Somalia' },
  ZA: { abbreviation: 'ZA', name: 'South Africa' },
  GS: { abbreviation: 'GS', name: 'South Georgia and the South Sandwich Islands' },
  KR: { abbreviation: 'KR', name: 'South Korea' },
  SS: { abbreviation: 'SS', name: 'South Sudan' },
  ES: { abbreviation: 'ES', name: 'Spain' },
  LK: { abbreviation: 'LK', name: 'Sri Lanka' },
  SD: { abbreviation: 'SD', name: 'Sudan' },
  SR: { abbreviation: 'SR', name: 'Suriname' },
  SJ: { abbreviation: 'SJ', name: 'Svalbard and Jan Mayen' },
  SZ: { abbreviation: 'SZ', name: 'Swaziland' },
  SE: { abbreviation: 'SE', name: 'Sweden' },
  CH: { abbreviation: 'CH', name: 'Switzerland' },
  SY: { abbreviation: 'SY', name: 'Syria' },
  TW: { abbreviation: 'TW', name: 'Taiwan' },
  TJ: { abbreviation: 'TJ', name: 'Tajikistan' },
  TZ: { abbreviation: 'TZ', name: 'Tanzania' },
  TH: { abbreviation: 'TH', name: 'Thailand' },
  TG: { abbreviation: 'TG', name: 'Togo' },
  TK: { abbreviation: 'TK', name: 'Tokelau' },
  TO: { abbreviation: 'TO', name: 'Tonga' },
  TT: { abbreviation: 'TT', name: 'Trinidad and Tobago' },
  TN: { abbreviation: 'TN', name: 'Tunisia' },
  TR: { abbreviation: 'TR', name: 'Turkey' },
  TM: { abbreviation: 'TM', name: 'Turkmenistan' },
  TC: { abbreviation: 'TC', name: 'Turks and Caicos Islands' },
  TV: { abbreviation: 'TV', name: 'Tuvalu' },
  UM: { abbreviation: 'UM', name: 'U.S. Minor Outlying Islands' },
  VI: { abbreviation: 'VI', name: 'U.S. Virgin Islands' },
  UG: { abbreviation: 'UG', name: 'Uganda' },
  UA: { abbreviation: 'UA', name: 'Ukraine' },
  AE: { abbreviation: 'AE', name: 'United Arab Emirates' },
  GB: { abbreviation: 'GB', name: 'United Kingdom' },
  US: {
    abbreviation: 'US',
    name: 'United States',
    states: {
      AL: { abbreviation: 'AL', name: 'Alabama' },
      AK: { abbreviation: 'AK', name: 'Alaska' },
      AS: { abbreviation: 'AS', name: 'America Samoa' },
      AZ: { abbreviation: 'AZ', name: 'Arizona' },
      AR: { abbreviation: 'AR', name: 'Arkansas' },
      AE: { abbreviation: 'AE', name: 'Armed Forces' },
      AA: { abbreviation: 'AA', name: 'Armed Forces Americas' },
      AP: { abbreviation: 'AP', name: 'Armed Forces Pacific' },
      CA: { abbreviation: 'CA', name: 'California' },
      CO: { abbreviation: 'CO', name: 'Colorado' },
      CT: { abbreviation: 'CT', name: 'Connecticut' },
      DE: { abbreviation: 'DE', name: 'Delaware' },
      DC: { abbreviation: 'DC', name: 'District of Columbia' },
      FM: { abbreviation: 'FM', name: 'Federated States of Micronesia' },
      FL: { abbreviation: 'FL', name: 'Florida' },
      GA: { abbreviation: 'GA', name: 'Georgia' },
      GU: { abbreviation: 'GU', name: 'Guam' },
      HI: { abbreviation: 'HI', name: 'Hawaii' },
      ID: { abbreviation: 'ID', name: 'Idaho' },
      IL: { abbreviation: 'IL', name: 'Illinois' },
      IN: { abbreviation: 'IN', name: 'Indiana' },
      IA: { abbreviation: 'IA', name: 'Iowa' },
      KS: { abbreviation: 'KS', name: 'Kansas' },
      KY: { abbreviation: 'KY', name: 'Kentucky' },
      LA: { abbreviation: 'LA', name: 'Louisiana' },
      ME: { abbreviation: 'ME', name: 'Maine' },
      MH: { abbreviation: 'MH', name: 'Marshall Islands' },
      MD: { abbreviation: 'MD', name: 'Maryland' },
      MA: { abbreviation: 'MA', name: 'Massachusetts' },
      MI: { abbreviation: 'MI', name: 'Michigan' },
      MN: { abbreviation: 'MN', name: 'Minnesota' },
      MS: { abbreviation: 'MS', name: 'Mississippi' },
      MO: { abbreviation: 'MO', name: 'Missouri' },
      MT: { abbreviation: 'MT', name: 'Montana' },
      NE: { abbreviation: 'NE', name: 'Nebraska' },
      NV: { abbreviation: 'NV', name: 'Nevada' },
      NH: { abbreviation: 'NH', name: 'New Hampshire' },
      NJ: { abbreviation: 'NJ', name: 'New Jersey' },
      NM: { abbreviation: 'NM', name: 'New Mexico' },
      NY: { abbreviation: 'NY', name: 'New York' },
      NC: { abbreviation: 'NC', name: 'North Carolina' },
      ND: { abbreviation: 'ND', name: 'North Dakota' },
      MP: { abbreviation: 'MP', name: 'Northern Mariana Islands' },
      OH: { abbreviation: 'OH', name: 'Ohio' },
      OK: { abbreviation: 'OK', name: 'Oklahoma' },
      OR: { abbreviation: 'OR', name: 'Oregon' },
      PW: { abbreviation: 'PW', name: 'Palau' },
      PA: { abbreviation: 'PA', name: 'Pennsylvania' },
      PR: { abbreviation: 'PR', name: 'Puerto Rico' },
      RI: { abbreviation: 'RI', name: 'Rhode Island' },
      SC: { abbreviation: 'SC', name: 'South Carolina' },
      SD: { abbreviation: 'SD', name: 'South Dakota' },
      TN: { abbreviation: 'TN', name: 'Tennessee' },
      TX: { abbreviation: 'TX', name: 'Texas' },
      UT: { abbreviation: 'UT', name: 'Utah' },
      VT: { abbreviation: 'VT', name: 'Vermont' },
      VI: { abbreviation: 'VI', name: 'Virgin Islands' },
      VA: { abbreviation: 'VA', name: 'Virginia' },
      WA: { abbreviation: 'WA', name: 'Washington' },
      WV: { abbreviation: 'WV', name: 'West Virginia' },
      WI: { abbreviation: 'WI', name: 'Wisconsin' },
      WY: { abbreviation: 'WY', name: 'Wyoming' }
    }
  },
  UY: { abbreviation: 'UY', name: 'Uruguay' },
  UZ: { abbreviation: 'UZ', name: 'Uzbekistan' },
  VU: { abbreviation: 'VU', name: 'Vanuatu' },
  VA: { abbreviation: 'VA', name: 'Vatican City' },
  VE: { abbreviation: 'VE', name: 'Venezuela' },
  VN: { abbreviation: 'VN', name: 'Vietnam' },
  WF: { abbreviation: 'WF', name: 'Wallis and Futuna' },
  EH: { abbreviation: 'EH', name: 'Western Sahara' },
  YE: { abbreviation: 'YE', name: 'Yemen' },
  ZM: { abbreviation: 'ZM', name: 'Zambia' },
  ZW: { abbreviation: 'ZW', name: 'Zimbabwe' }
};

export const isEuropeanUnionCountry = (abbreviation: string): boolean => {
  abbreviation = abbreviation?.toUpperCase();

  const countries = [
    'AT', 'BE', 'BG', 'CY', 'CZ', 'DK', 'EE', 'ES', 'FI', 'FR',
    'DE', 'GB', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT',
    'NL', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK', 'HR'
  ];

  return countries.some(c => c === abbreviation);
};

const paypalBlacklist = [
  'IN', // India
  'PK', // Pakistan
  'KE', // Kenya
  'NG', // Nigeria
  'ID' // Indonesia
];

const paypalWhitelist = [
  'US',
  'UK',
  'CA',
  'FR',
  'ES',
  'AU',
  'DE',
  'NL',
  'BE'
];

export function isPaypalBlacklisted (country: string) {
  return paypalBlacklist.includes(country);
}

export function isPaypalWhitelisted (country: string) {
  return paypalWhitelist.includes(country);
}

export function getCouponCode (req: Request) {
  let couponCode: any = null;
  if (req.query.cpc && req.query.cpc !== '') {
    couponCode = req.query.cpc;
  } else if (req.cookies.evntcpc) {
    couponCode = req.cookies.evntcpc;
  } else if (req.cookies.upcpc) {
    couponCode = req.cookies.upcpc;
  }
  return couponCode;
}

export function getPaymentCurrency (countryCode: string) {
  if (countryCode === 'GB') {
    return 'GBP';
  } else if (isEuropeanUnionCountry(countryCode)) {
    return 'EUR';
  } else {
    return 'USD';
  }
}

export function getCurrencySymbol (currency: string) {
  switch (currency) {
    case 'GBP':
      return '£';
    case 'EUR':
      return '€';
    default:
      return '$';
  }
}

export const REQUIRED_ADDRESS_COUNTRIES = ['CA', 'US', 'GB'];
